var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "dropdown mr-3 d-none" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "inspectorDropdown" }
              },
              [
                _c("li", { staticClass: "d-none" }, [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "default"
                        }
                      }
                    },
                    [_vm._v("Default")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("Main")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "animations"
                        }
                      }
                    },
                    [_vm._v("Animations")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "light"
                        }
                      }
                    },
                    [_vm._v("Light")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "sound"
                        }
                      }
                    },
                    [_vm._v("Sound")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "movement"
                        }
                      }
                    },
                    [_vm._v("Movement")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "effects"
                        }
                      }
                    },
                    [_vm._v("Effects")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "tts"
                        }
                      }
                    },
                    [_vm._v("TTS")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("span", { staticClass: "text-primary ml-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$parent.activeComponentTitle) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "btn-menu-wrapper navbar navbar-expand-lg" },
            [
              _c("ul", { staticClass: "navbar-nav" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c(
                    "span",
                    {
                      staticClass: "nav-link",
                      class: { active: _vm.activeComponent == "main" },
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("\n              Main\n            ")]
                  )
                ])
              ])
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "inspector-wrapper" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-9" },
            [_vm.activeComponent == "main" ? _c("maininspector") : _vm._e()],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-3" }, [
            _vm.selectedCharecterName
              ? _c("h4", [_vm._v(_vm._s(_vm.selectedCharecterName))])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "selected-char-imgwrap" }, [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: _vm.selectedCharecter }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(2)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-card-header dropdown-toggle",
        attrs: {
          type: "button",
          id: "inspectorDropdown",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "heading-icon mr-2",
          attrs: { src: require("@/assets/addplus_icon.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "pr-2 text-capitalize" }, [_vm._v(" Add")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-3" }, [
      _c("img", {
        staticClass: "heading-icon mr-2",
        attrs: { src: require("@/assets/device_hub_icon.svg") }
      }),
      _vm._v(" Inspector")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4 d-none" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("button", { staticClass: "btn btn-outline-primary mr-3" }, [
          _vm._v("Save")
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "btn btn-outline-secondary" }, [
          _vm._v("Cancel")
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-694d787d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694d787d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/lightsInspector.vue
// module id = null
// module chunks = 